import {
  FDList,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import Relationship from 'facet-rest/src/domain/Relationship';
import {
  AuthenticationFactorItem,
} from 'Organisms/AuthenticationFactorList/AuthenticationFactorItems/AuthenticationFactorItem';

export const AuthenticationFactorItems = ({
  relationship,
  authFactorIncludedResources,
}) => {
  if (!relationship) {
    return null;
  }

  const includedResourcesData = relationship?.data;

  const includedAuthFactorItems = includedResourcesData?.map((d) => {
    return authFactorIncludedResources.findResource(d);
  });

  return includedAuthFactorItems.length > 0 ? (
    <FDList>
      {includedAuthFactorItems.map((afi) => (<AuthenticationFactorItem afi={afi} key={afi.id()} />))}
    </FDList>) : null;
};

AuthenticationFactorItems.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  authFactorIncludedResources: PropTypes.array.isRequired,
};
